import React from 'react';
import ReactDOM from 'react-dom/client';
import LienzoDiagrama from './Components/LienzoDiagrama';
import './index.css';
import reportWebVitals from './reportWebVitals';
import EditorApp from "../src/EditorApp";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <EditorApp/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
